<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.user-activities.title' | translate }}
    @if (modify) {
    <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
      pTooltip="{{'widgets.user-activities.edit' | translate}}">
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
    </a>
    }
    @if (!modify) {
    <small class="date-font"><i>({{initialDate | dateMoment:shortDate}} -
        {{finalDate | dateMoment:shortDate}})</i></small>
    }
  </div>

  <div class="amSuite-widget-block height-auto">
    @if (activities && activities.length > 0) {
    <div class="cw-list">
      @for (act of activities; track $index) {
      <article class="cw-row">
        <span class="cw-ico" role="img" [attr.aria-label]="getStateLabel(act.workingState)">
          <p-tag [severity]="stateConfig[act.workingState].severity"
                [icon]="stateConfig[act.workingState].icon + ' font-semibold'"
                [rounded]="true"
                styleClass="p-tag-outlined">
          </p-tag>
        </span>
        <div class="cw-main">
          <a class="cw-rtitle" href="javascript:void(0)" (click)="modify ? '' : onSelectActivity(act)"
            [pTooltip]="act.subject" tooltipPosition="bottom">{{ act.subject }}</a>
          @if (act.activityTypology?.name) {
          <div class="cw-tag">{{ act.activityTypology.name }}</div>
          }
          @if (act.date) {
          <div class="cw-date">{{ act.date | dateMoment:shortDate }}</div>
          }
          @if (act.parties && act.parties.length > 0) {
          <div class="cw-sub">
            @for (p of act.parties; track $index) {
            <span>{{ p.partyName }}</span>
            }
          </div>
          }
        </div>
      </article>
      }
    </div>
    }
    @if (activities && activities.length === 0) {
    <div>
      <div class="row noResultsLabel"> {{ 'app.noData' | translate }}</div>
    </div>
    }
    @if (!activities) {
    <div>
      <div class="m-0 o-0">
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div>
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
